import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { BarPlot } from "../components/BarPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.bar_tool_name()}
        toolPath="/bar-chart"
      />
      <SciHeader title={m.bar_h1()} intro={m.bar_intro()} />

      <BarPlot />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.bar_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.bar_ex1(), m.bar_ex2(), m.bar_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.bar_faq_q1(), a: m.bar_faq_a1() },
          { q: m.bar_faq_q2(), a: m.bar_faq_a2() },
          { q: m.bar_faq_q3(), a: m.bar_faq_a3() },
          { q: m.bar_faq_q4(), a: m.bar_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
